import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { colors } from '../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import BidAskBox from '../../../../charts/d3/candlestickchart/newCandleChart/chartHeader/BidAskBox';
import PnLDisplay from '../pnLDisplay/PnLDisplay';
import {
  definingSetupDetails,
  definingTradeDirection,
} from '../tradePlanIdentityDisplay/identityDisplayUtils';
import { CloseRow } from './closeRow/CloseRow';
import style from './InPositionTopRow.module.css';
import { OpenRow } from './openRow/OpenRow';
import { TopRowBox } from './topRowBox/TopRowBox';
import { TopRowFillPrice } from './topRowBox/TopRowFillPrice';
import { TopRowExpandButton } from './topRowExpandButton/TopRowExpandButton';
import QtyDisplay from "../qtyDisplay/QtyDisplay"
const directionColorMap = {
  SHORT: colors.red,
  LONG: colors.green,
  BOTH: colors.blue,
};
export const InPositionTopRow = observer(({ tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId];
  
  const direction = definingTradeDirection(tradePlan);
  const [type, setType] = useState('pct');

  return (
    <div className={style.container}>
      <div className={style.topRow}>
        <TopRowBox
          backgroundColor={colors.grey}
          color={colors.lightGrey}
          width="100px"
        >
          {tradePlan.symbol}
        </TopRowBox>
        <TopRowBox
          backgroundColor={colors.grey}
          color={directionColorMap[direction]}
          width="100px"
        >
          {direction}
        </TopRowBox>
        <QtyDisplay tradePlanId={tradePlanId} />
        {tradePlan.savedConfigurationTitle ? (
          <TopRowBox
            backgroundColor={colors.grey}
            color={colors.lightGrey}
            width="205px"
            justifyContent={
              tradePlan.savedConfigurationTitle.length > 20
                ? 'flexStart'
                : 'center'
            }
          >
            {tradePlan.savedConfigurationTitle}
          </TopRowBox>
        ) : (
          <TopRowBox
            backgroundColor={colors.grey}
            color={colors.lightGrey}
            width="205px"
          >
            {definingSetupDetails(tradePlan)}
          </TopRowBox>
        )}
      </div>
      {/* <div className={style.secondRow}>
        <TradePlanIdentityDisplay tradePlanId={tradePlanId} />
      </div> */}
      <div className={style.thirdRow}>

        <TopRowFillPrice positionId={tradePlan.positionId} />
        <PnLDisplay tradePlanId={tradePlanId} />
        <BidAskBox
          symbol={tradePlan.symbol}
          dataSource={tradePlan.dataSource}
        />
      </div>
      <div className={style.thirdRow}>
        {/* <CloseQtySection tradePlanId={tradePlanId} type={type} setType={setType}/> */}
        <OpenRow tradePlanId={tradePlanId} type={type} setType={setType}/>
      </div>
      <div className={style.thirdRow}>
        {/* <ClosePositionSection tradePlanId={tradePlanId} type={type}/>
         */}
        <CloseRow tradePlanId={tradePlanId} type={type}/>
      </div>
      <div className={style.bottomRow}>
        <TopRowExpandButton
          height= "24px"
          width= "520px"
          backgroundColor={colors.grey}
          fill={colors.lightGrey}
          clickHandler={() => tradePlanStore.flipExpandedState(tradePlanId)}
          expanded={tradePlan.expanded}
        />
      </div>
    </div>
  );
});

InPositionTopRow.propTypes = {
  expanded: PropTypes.bool,
  setExpanded: PropTypes.func,
  tradePlanId: PropTypes.string,
};
